import {EvaluatedCell} from 'notebook/tables/excess/EvaluationConstants';
import {hasOnlyNonBlockingErrors} from 'notebook/tables/excess/Util';

import {LiveRowMetadata} from '../StructuredTableConstants';

/** Returns true if the cell is a non-parent (child) cell in a merged region. These cells
 *  have their error copied from the parent by _tagMergedCells and should be skipped when counting. */
function isMergedChildCell(rowIdx: number, colIdx: number, cell: EvaluatedCell): boolean {
  return cell.mergedBox != null && (rowIdx !== cell.mergedBox.minI || colIdx !== cell.mergedBox.minJ);
}

/**
 * Determines whether a table has validation errors that should block other actions (e.g. table submission)
 * using the computedTable and the structured table's live metadata (currently only the live row metadata).
 */
export default function hasBlockingValidationErrors(
  computedTable: Array<Array<EvaluatedCell>>,
  {liveRowMetadataByRow}: {liveRowMetadataByRow?: Array<LiveRowMetadata>} = {}
): boolean {
  for (const [rowIdx, evaluatedRow] of computedTable.entries()) {
    // We should ignore any validation errors if the row is archived.
    if (liveRowMetadataByRow?.[rowIdx]?.archivePurpose != null) {
      continue;
    }
    for (const evaluatedCell of evaluatedRow) {
      if (evaluatedCell.error && !hasOnlyNonBlockingErrors(evaluatedCell.error)) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Counts the number of cells in the table that have blocking validation errors.
 */
export function countBlockingValidationErrors(computedTable: Array<Array<EvaluatedCell>>): number {
  let count = 0;
  for (const [rowIdx, evaluatedRow] of computedTable.entries()) {
    for (const [colIdx, evaluatedCell] of evaluatedRow.entries()) {
      if (isMergedChildCell(rowIdx, colIdx, evaluatedCell)) {
        continue;
      }
      if (evaluatedCell.error && !hasOnlyNonBlockingErrors(evaluatedCell.error)) {
        count++;
      }
    }
  }
  return count;
}
